import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Twitter, Linkedin, HelpCircle, Instagram, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import logo from '../images/logo.svg';

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-left">
        <img src={logo} alt="Sylents Logo" className="footer-logo" />
        <p className="footer-copyright">© {currentYear} Sylents GesbR. All rights Reserved</p>
        <p className="footer-made-with-love">{t('footerMadeWithLove')}</p>
      </div>

      <div className="footer-links">
        <a href="#" onClick={(e) => {
          e.preventDefault();
          const faqButton = document.querySelector('.floating-faq-button');
          if (faqButton) faqButton.click();
        }} className="footer-link">
          <HelpCircle size={16} />
          {t('faqTitle')}
        </a>
        <Link to="/imprint" className="footer-link">
          <span className="imprint-icon">§</span>
          {t('footerImprint')}
        </Link>
        <Link to="/privacy" className="footer-link">
          <Shield size={16} />
          {t('footerPrivacy')}
        </Link>
      </div>

      <div className="footer-social-icons">
        <a href="https://twitter.com/sylentsboats" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="social-icon-link">
          <Twitter size={20} />
        </a>
        <a href="https://linkedin.com/company/sylents" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-icon-link">
          <Linkedin size={20} />
        </a>
        <a href="https://www.instagram.com/sylents.at" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon-link">
          <Instagram size={20} />
        </a>
      </div>
    </footer>
  );
}

export default Footer; 